import React, { useEffect } from "react";
import axiosApi from "../server/service";
import { useUserStore } from "../store/AuthUserStore";

const AppInitializer: React.FC = () => {
  const setUser = useUserStore((state) => state.setUser);
    const logout = useUserStore((state) => state.logout);

  useEffect(() => {
    const fetchUser = async () => {
      const token = localStorage.getItem("token");
      if (!token) return; 

      try {
        const response = await axiosApi.get("/api/auth/verify-token"); 
        if (response.data.valid) {
          setUser(response.data.user); 
        }
      } catch (error) {
        console.error("Token verification failed:", error);

        // Optionally: logout user if token invalid
        logout();
      }
    };

    fetchUser();
  }, [setUser]);

  return null; 
};

export default AppInitializer;
